// Default
//import '../../custom/js/default';

//// JS
//import '../../custom/js/indexOptimized';
//import Hero from '../../custom/js/components/hero'; 
import '../../custom/js/pages/getInvolved';

//// Base SCSS
//import '../../custom/scss/style.scss';

//$(() => {
//	const hero = new Hero();
//	hero.init();
//});